module.exports = __webpack_public_path__ + "img/11.2f893a07.jpg";